import type { StoreSpecial as V3StoreSpecial } from '@iheartjane/data-access';
import type { Nullable } from '@iheartjane/types';
import compact from 'lodash-es/compact';

/* eslint-disable-next-line no-restricted-imports */
import type { StoreSpecial } from '@jane/shared/models';
import type { StoreSpecial as ZStoreSpecial } from '@jane/shared/types';

import type { PathMatchParams } from '../../../types';

const ROUTE_ID_TO_SOURCE: Record<string, string[]> = {
  cartPdp: ['bag'],
  cartWeightModal: ['bag'],
  special: ['special'],
  specialPdp: ['special'],
  specialWeightModal: ['special'],
  featuredPdp: ['featured'],
  featuredWeightModal: ['featured'],
  rowPdp: ['featured'],
  rowWeightModal: ['featured'],
  all: ['shop all products'],
  sale: ['deals tab'],
};

interface GetSourceArgs {
  currentSpecial?: Nullable<StoreSpecial | ZStoreSpecial | V3StoreSpecial>;
  isTopper: boolean;
  matches: PathMatchParams[];
  pathname: string;
}

export const getSource = ({
  currentSpecial,
  isTopper,
  matches,
  pathname,
}: GetSourceArgs) => {
  if (pathname.endsWith('/search') || pathname.includes('/search/')) {
    return ['quick search results'];
  }
  if (pathname.includes('search-results')) {
    return ['search results screen'];
  }
  if (currentSpecial) {
    if (currentSpecial.special_type === 'product') {
      return ['product type deals'];
    }
    if (currentSpecial.special_type === 'bundle') {
      return ['bundles'];
    }
  }

  const match = matches.find((m) => m.pathname === pathname);

  if (match) {
    const category = match.params['category'];
    const featuredCategory = match.params['featuredCategory'];
    const rowId = match.params['rowId'];

    if (match.id in ROUTE_ID_TO_SOURCE) {
      return ROUTE_ID_TO_SOURCE[match.id];
    } else if (category) {
      if (category in ROUTE_ID_TO_SOURCE) {
        return ROUTE_ID_TO_SOURCE[category];
      } else {
        return compact([category]);
      }
    } else if (featuredCategory || rowId) {
      return ['featured'];
    }
  }

  if (isTopper) {
    return ['cart toppers'];
  }

  return [];
};
